/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { ListSessions1QueryResponse, ListSessions1400, ListSessions1401, ListSessions1404, ListSessions1409, ListSessions1500 } from "../../types/ListSessions1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getListSessions1Url() {
  const res = { method: 'GET', url: `/api/research-chat` as const }
  return res
}

/**
 * @description Returns all research chat sessions created by the current user.
 * @summary List user's chat sessions
 * {@link /api/research-chat}
 */
export async function listSessions1(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListSessions1QueryResponse, ResponseErrorConfig<ListSessions1400 | ListSessions1401 | ListSessions1404 | ListSessions1409 | ListSessions1500>, unknown>({ method : "GET", url : getListSessions1Url().url.toString(), ... requestConfig })
  return res.data
}